import { Route, Routes } from "react-router-dom";
import AboutUs from "./AboutUs";
import Blog from "./Blog";
import BlogDetails from "./BlogDetails";
import BookADemo from "./BookADemo";
import ErrorPage from "./ErrorPage";
import Faq from "./Faq";
import Features from "./Features";
import ForgetPassword from "./ForgetPassword";
import FrameWorkIso27001 from "./FrameWorkIso27001";
import FrameWorkNdpr from "./FrameWorkNdpr";
import FrameWorkPcidss from "./FrameWorkPcidss";
import FrameWorks from "./FrameWorks";
import FrameWorkSoc2 from "./FrameWorkSoc2";
import Glossary from "./Glossary";
import Home from "./Home";
import Integration from "./Integration";
import Partnership from "./Partnership";
import Pricing from "./Pricing";
import Privacy from "./Privacy";
import Signin from "./Signin";
import Signup from "./Signup";
import Success from "./Success";
import Terms from "./Terms";
import Smartguard from "./Smartguard";

const Pages = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/features" element={<Features />} />
      <Route path="/frameworks/iso27001" element={<FrameWorkIso27001 />} />
      <Route path="/frameworks/soc2" element={<FrameWorkSoc2 />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/partner" element={<Partnership />} />
      <Route path="/frameworks/pcidss" element={<FrameWorkPcidss />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:id" element={<BlogDetails />} />
      <Route path="/glossary" element={<Glossary />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/frameworks/ndpr" element={<FrameWorkNdpr />} />
      <Route path="/frameworks/integration" element={<Integration />} />
      <Route exact path="/frameworks" element={<FrameWorks />} />
      <Route path="/auth/sign-in" element={<Signin />} />
      <Route path="/auth/sign-up" element={<Signup />} />
      <Route path="/book-a-demo" element={<BookADemo />} />
      <Route path="/auth/reset-password" element={<ForgetPassword />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/success" element={<Success />} />
      <Route path="/smartguard" element={<Smartguard />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export default Pages;
